import { authService } from "../../../services/auth.service";
import styled from "styled-components";
import { Hypertext, TypographyVariant } from "../../../components/ui-kit";
import { AppRoutes } from "../../../constants/routes";
import { Title } from "../styles";
import { useAuthUserContext } from "../../../context/AdministratorContextProvider";

export interface ContentCardProps {
  title: string;
  children?: React.ReactNode | React.ReactNode[] | JSX.Element | JSX.Element[];
  disableEndSession?: boolean;
}

const Wrapper = styled.div`
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 10px;
  padding: 2rem 3rem;
  @media (max-width: 767px) {
    padding: 1.5rem 1.25rem;
  }
`;

const EndSessionWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 25px;
`;

export const ContentCard: React.FunctionComponent<ContentCardProps> = ({
  title,
  children,
  disableEndSession,
}) => {
  const { clearAuthUser: clearUser } = useAuthUserContext();

  const endSession = async () => {
    await authService.signOut();
    clearUser();
  };

  return (
    <Wrapper>
      <Title variant={TypographyVariant.HEADER1}>{title}</Title>
      {children}
      {!disableEndSession && (
        <EndSessionWrapper>
          <Hypertext
            onClick={endSession}
            to={AppRoutes.Open.Auth.SIGN_IN_START}
          >
            Quit
          </Hypertext>
        </EndSessionWrapper>
      )}
    </Wrapper>
  );
};
